// Convierte un monto numérico a su expresión en palabras (español rioplatense),
// pensado para el campo "Recibí la cantidad de pesos ___" del recibo.

const UNIDADES = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
const DIEZ_19 = ["diez", "once", "doce", "trece", "catorce", "quince", "dieciséis", "diecisiete", "dieciocho", "diecinueve"];
const VEINTI = ["veinte", "veintiuno", "veintidós", "veintitrés", "veinticuatro", "veinticinco", "veintiséis", "veintisiete", "veintiocho", "veintinueve"];
const DECENAS = ["", "", "veinte", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
const CENTENAS = ["", "ciento", "doscientos", "trescientos", "cuatrocientos", "quinientos", "seiscientos", "setecientos", "ochocientos", "novecientos"];

// Apócope de "uno" -> "un" / "veintiuno" -> "veintiún" cuando le sigue un
// sustantivo (mil, millón, pesos).
const apocopar = (t) =>
  t.replace(/veintiuno$/, "veintiún").replace(/(\b)uno$/, "$1un");

// Convierte un grupo de 0 a 999 a palabras.
const grupo = (n) => {
  if (n === 0) return "";
  if (n === 100) return "cien";
  const c = Math.floor(n / 100);
  const resto = n % 100;
  let out = c ? CENTENAS[c] : "";
  if (resto) {
    if (out) out += " ";
    if (resto < 10) out += UNIDADES[resto];
    else if (resto < 20) out += DIEZ_19[resto - 10];
    else if (resto < 30) out += VEINTI[resto - 20];
    else {
      const d = Math.floor(resto / 10);
      const u = resto % 10;
      out += DECENAS[d];
      if (u) out += " y " + UNIDADES[u];
    }
  }
  return out;
};

// Entero -> palabras (hasta cientos de millones, suficiente para alquileres).
export const numeroALetras = (num) => {
  let n = Math.floor(Math.abs(Number(num) || 0));
  if (n === 0) return "cero";

  const millones = Math.floor(n / 1000000);
  const miles = Math.floor((n % 1000000) / 1000);
  const resto = n % 1000;
  const partes = [];

  if (millones) {
    partes.push(millones === 1 ? "un millón" : apocopar(grupo(millones)) + " millones");
  }
  if (miles) {
    partes.push(miles === 1 ? "mil" : apocopar(grupo(miles)) + " mil");
  }
  if (resto) {
    partes.push(grupo(resto));
  }
  // Apócope final porque siempre le sigue "pesos".
  return apocopar(partes.join(" "));
};

// Monto completo en letras: "Trescientos cincuenta mil pesos" (+ "con XX/100").
export const montoEnLetras = (monto) => {
  const valor = Number(monto) || 0;
  const entero = Math.floor(valor);
  const centavos = Math.round((valor - entero) * 100);
  const letras = numeroALetras(entero);
  // "un millón de pesos" / "dos millones de pesos", pero "un millón quinientos
  // mil pesos" (sin "de") cuando hay resto.
  const conector = /mill(ón|ones)$/.test(letras) ? "de pesos" : entero === 1 ? "peso" : "pesos";
  let texto = `${letras} ${conector}`;
  if (centavos > 0) texto += ` con ${String(centavos).padStart(2, "0")}/100`;
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};
